<template>
	<div class="swipeDeviceOverlay">
		<div v-if="!hidden" class="iconContainer">
			<div class="arrow"><i class="fa fa-arrow-up"></i></div>
			<div class="text"> {{ $t('swipeUp') }}</div>
		</div>
	</div>
</template>

<script>
// DEPRECATED
export default {

  data: function(){
    return{
    	hidden: false,
    }
  },

  mounted(){

  	var self = this

  }

}
</script>

<style lang="scss" scoped>

	.swipeDeviceOverlay{
		position:absolute;
		top:0;
		background-color:rgba(0,0,0,.9);
		width:100%;
		height:100%;
		color: white;
		z-index: 9999999999;

		.text{

		}

		.arrow{
			position: absolute;
			left: 50%;
			margin-left: -25px;
		}

		.text{
			font-size: 20px;
		    width: 100%;
		    text-align: center;
		    top: 160px;
		    position: absolute;
		}

		.iconContainer{
		    position: absolute;
		    top: 5%;
		    font-size: 50px;
		    width: 100%;

		    i{
		    	font-size: 50px;
		    }
		}


	}

	.swipeDeviceOverlay{	display:block; }

	.swipeDeviceOverlay .arrow{
		animation: MoveUpDown 2s infinite;
	}

	/* KEYFRAMES
	------------------------------------------- */
	/* Animate width + height */
	@keyframes MoveUpDown {
	 0% {
	    top: 80px;
		}
		100% {
		     top: 5px;
		}
	}

</style>



// WEBPACK FOOTER //
// SwipeToMinimal.vue?5a037614